<script lang="ts">
    import type Customers from "@/schemas/public/Customers";
    import AppLayout from "@/layouts/AppLayout.svelte";
    import {Plus} from "lucide-svelte";
    import type Blocks from "@/schemas/public/Blocks";
    import type {Field} from "@/types/types";
    import CustomerTable from "@/components/customers/CustomerTable.svelte";
    import CreateCustomerModal from "@/components/customers/CreateCustomerModal.svelte";

    type Row = Customers;

    type Props = {
        blocks: (Blocks & { fields: Field[] })[];
        customerTypeOptions?: Record<string, string>;
        availableOrganisations?: { id: string; name: string }[];
    };

    let {blocks, customerTypeOptions = {}, availableOrganisations = []}: Props = $props();

    let breadcrumbs = $state([
        {title: 'Customers', href: route('customers.index')},
    ]);

    let showCreateCustomerModal = $state(false);

    function openCreateCustomerModal() {
        showCreateCustomerModal = true;
    }

    let view = "index";

    let actionbuttons = $state([
        {
            title: 'Add New Customer',
            href: undefined,
            icon: Plus,
            onClick: openCreateCustomerModal,
        },
    ]);

</script>

<svelte:head>
    <title>Customers</title>
</svelte:head>

<!--<HeaderActionButtons>-->
<!--    {#if meta.user?.view_type === 'super-admin' || meta.user?.view_type === 'supervisory-body'}-->
<!--        <Button href={route('assessors.create')}>Add New Assessor</Button>-->
<!--    {/if}-->

<!--</HeaderActionButtons>-->
<AppLayout {breadcrumbs} {actionbuttons}>
    <CustomerTable {view}>

    </CustomerTable>

   <CreateCustomerModal
        bind:show={showCreateCustomerModal}
        {blocks}
        {customerTypeOptions}
        {availableOrganisations}
   />

</AppLayout>
